module.exports = __webpack_public_path__ + "img/logo.942c8815.png";